import { Position, Tooltip, Icon } from "@blueprintjs/core";
import React from 'react';

export function showDialysisIndicator(customFields) {
    const purposeCode = 'purpose code';
    if (customFields && customFields.length > 0) {
        var purposeCodeValue = '';
        purposeCodeValue = customFields.find(customField => customField.fieldName && customField.fieldName.toLowerCase() === purposeCode)?.fieldValue;

        if (purposeCodeValue && purposeCodeValue.toLowerCase() === "dialysis") {
            return (
                <Tooltip content="Dialysis" position={Position.BOTTOM}>
                    <Icon icon="tint" />
                </Tooltip>)
        }
    }
    return null;
}

export function showVipIndicator(isVip) {

    if (isVip === true) {
        return (
            <Tooltip content="VIP" position={Position.BOTTOM}>
                <Icon icon="crown" />
            </Tooltip>)
    }
    return null;
}

export function showWcIndicator(wheelchairType) {

    if (wheelchairType?.includes('Non-ADA Compliant Wheelchair')) {
        return (
            <Tooltip content="Oversize WC" position={Position.BOTTOM}>
                <Icon icon="blocked-person" />
            </Tooltip>);
    }
    return null;
}
